import * as React from 'react';
import { ModalVariant } from '../custom-modals';
import { DrawerLayout } from './drawer-layout';
import ModalLayout from './modal-layout';

export interface ModalDesktopProps {
  variant?: ModalVariant;

  /**
   * Custom Content Element
   */
  children: React.ReactNode;

  /**
   *Configure modal layout
   */
  layout: 'drawer' | 'modal';

  /**
   * Whether is open
   */
  isOpen: boolean;

  /**
   * Drawer props only used ONLY when layout == drawer
   *
   */
  drawerProps: {
    drawerPosition?: 'left' | 'right';
    drawerStyles?: React.CSSProperties;
    drawerWidth?: number;
  };

  /**
   * Modal props only used ONLY when layout == modal
   */
  modalProps: {
    modalStyles?: React.CSSProperties;
  };

  /**
   * Callback when to close it
   */
  onClose: () => void;
}

export function ModalDesktop({
  variant,
  layout,
  isOpen,
  children,
  drawerProps = {},
  modalProps = {},
  onClose,
}: ModalDesktopProps) {
  const { drawerPosition, drawerStyles, drawerWidth } = drawerProps;
  const { modalStyles } = modalProps;

  let dialogEl = null;
  switch (layout) {
    case 'drawer':
      dialogEl = (
        <DrawerLayout
          onClose={onClose}
          isOpen={isOpen}
          styles={drawerStyles}
          width={drawerWidth}
          position={drawerPosition}
          variant={variant}
        >
          {children}
        </DrawerLayout>
      );
      break;
    case 'modal':
    default:
      dialogEl = (
        <ModalLayout onClose={onClose} isOpen={isOpen} styles={modalStyles}>
          {children}
        </ModalLayout>
      );
      break;
  }

  return isOpen ? dialogEl : null;
}

export default ModalDesktop;
